import { useState, useEffect, useCallback } from "react";
import { useNavigate, generatePath, useParams } from "react-router-dom";
import Header from "../common/Header";
import Sidebar from "../common/Sidebar";
import http from "../../api/server";
import { IconButton } from "@mui/material";
import useGetClientId from "../../hooks/useGetClientId";
import {
  DELETE_PROPERTY_BY_MASTER_ID,
  GET_ALL_PROPERTY_BY_CLIENT_ID,
  GET_BLOCK_BY_CLIENT_ID,
  GET_USERS_ROLE_BY_CLIENT_ID,
  GET_PROPERTIES_LIST,
  RMS_LINK,
  GET_PROPERTY_WITH_BUILDING,
  EXPORT_EXCEL_PROPERTIES
} from "../../api/apiPath";
import Toaster from "../common/Toaster";
import { useSelector } from "react-redux";
import UpdateProperty from "../unused/UpdateProperty";
import useGetCity from "../../hooks/useGetCity";
import DynamicTable from "../common/DynamicTable";
import DynamicTiles from "../common/DynamicTiles";
import ConfirmationPopup from "../common/ConfirmationPopup";
import LoadingComponent from "../common/LoadingComponent";
import SidebarIcons from "../common/SidebarIcons";
import AddSiteBlock from "./AddSiteBlock";
// import del from "../../assets/img/del.png";
import Footer from "../common/Footer";
import BottomBarIcons from "../common/BottomBarIcons";
import ClearIcon from "@mui/icons-material/Clear";
import searchIcon from "../../assets/img/searchIcon.png";
import AddIcon from "@mui/icons-material/Add";
import AutocompleteInput from "../common/AutocompleteInput";
import activeHistoryIcon from "../../assets/img/activeHistoryIcon.png";
// import activeEditIcon from "../../assets/img/activeEditIcon.png";
// import activeDeleteIcon from "../../assets/img/aciveDeleteIcon.png";
import PropertyList from "./Property";
// import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Tooltip from "@mui/material/Tooltip";
import downloadIcon from "../../assets/img/excleExport.png";


const AddProperty = () => {
  const [toolbar, setToolBar] = useState({
    searchText: "",
    property_name: "Propertyname",
    building_name: "BuildingName",
    property_address: "Propertyaddress",
    inspector: "Inspector",
    approver: "Approver",
    propertyType: "Property Type",
  });

  // Determine whether any toolbar filter is actively applied.
  const isAnyFilterApplied =
    toolbar.searchText !== "" ||
    toolbar.property_name !== "Propertyname" ||
    toolbar.building_name !== "BuildingName" ||
    toolbar.inspector !== "Inspector" ||
    toolbar.approver !== "Approver" ||
    toolbar.propertyType !== "Property Type";

  const { userObj } = useSelector((state) => state.user);
  const [hideSidebar, setHideSidebar] = useState(false);
  const [blocksList, setBlocksList] = useState(null);
  const [approverList, setApproverList] = useState(null);
  const [inspectorList, setInspectorList] = useState(null);
  const [allPropertyList, setAllPropertyList] = useState(null);
  const [editProperty, setEditProperty] = useState(null);
  const [renderAddProperty, setRenderAddProperty] = useState(false);
  const [renderUpdateProperty, setRenderUpdateProperty] = useState(false);
  const [city, setCity] = useState(null);
  const [loading, setLoading] = useState(true);
  const cityObj = useGetCity();
  const [activeView, setActiveView] = useState("tile");
  const navigate = useNavigate();
  const { clientNameParam } = useParams();
  const [properties, setProperties] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  //building
  // const [propertyBuildingList, setPropertyBuildingList] = useState([]);

  const [showRmsLinkPopup, setShowRmsLinkPopup] = useState(false);
  const [rmsLinkData, setRmsLinkData] = useState({
    description: "",
    href: "",
  });

  const open = Boolean(anchorEl);

  const handleMenuOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };
//filter function
  const filteredRows = allPropertyList?.filter((row) => {
    const matchesSearch =
      !toolbar.searchText ||
      row.propertyName
        ?.toLowerCase()
        .includes(toolbar.searchText.toLowerCase()) ||
      row.propertyLocation
        ?.toLowerCase()
        .includes(toolbar.searchText.toLowerCase()) ||
      row.propertyStatus
        ?.toLowerCase()
        .includes(toolbar.searchText.toLowerCase()) ||
      (Array.isArray(row.inspectors) &&
        row.inspectors.some((inspector) =>
          inspector.fullName
            ?.toLowerCase()
            .includes(toolbar.searchText.toLowerCase()),
        )) ||
      (Array.isArray(row.approvers) &&
        row.approvers.some((approver) =>
          approver.fullName
            ?.toLowerCase()
            .includes(toolbar.searchText.toLowerCase()),
        ));

    const matchesName =
      toolbar.property_name === "Propertyname" ||
      row.propertyName === toolbar.property_name;

    const matchesBuilding =
      toolbar.building_name === "BuildingName" ||
      row.blockName === toolbar.building_name;

    const matchesInspector =
      toolbar.inspector === "Inspector" ||
      (Array.isArray(row.inspectors) &&
        row.inspectors.some(
          (inspector) => inspector.fullName === toolbar.inspector,
        ));

    const matchesApprover =
      toolbar.approver === "Approver" ||
      (Array.isArray(row.approvers) &&
        row.approvers.some(
          (approver) => approver.fullName === toolbar.approver,
        ));

    const matchesUserType =
      toolbar.propertyType === "Property Type" ||
      row.propertyStatus === toolbar.propertyType;
    // console.log(propertyBuildingList);
    return (
      matchesSearch &&
      matchesName &&
      matchesInspector &&
      matchesApprover &&
      matchesUserType &&
      matchesBuilding
    );
  });
  //filter dropdown values
  const allInspectors = Array.isArray(allPropertyList)
    ? allPropertyList.flatMap((property) =>
        Array.isArray(property.inspectors) ? property.inspectors : [],
      )
    : [];

  const uniqueInspectors = [
    ...new Map(
      allInspectors.map((inspector) => [inspector.userId, inspector]),
    ).values(),
  ];

  const allApprovers = Array.isArray(allPropertyList)
    ? allPropertyList.flatMap((property) =>
        Array.isArray(property.approvers) ? property.approvers : [],
      )
    : [];

  const uniqueApprovers = [
    ...new Map(
      allApprovers.map((approver) => [approver.userId, approver]),
    ).values(),
  ];

  const propertyNameList = [
    ...new Map(
      allPropertyList?.map((item) => [
        item.propertyName,
        { name: item.propertyName },
      ]) || [],
    ).values(),
  ].filter((item) => item.name);

  const buildingNameList = [
    ...new Map(
      allPropertyList
        ?.filter((item) =>
          toolbar.property_name !== "Propertyname"
            ? item.propertyName === toolbar.property_name
            : true,
        )
        .map((item) => [item.blockName, { name: item.blockName }]) || [],
    ).values(),
  ].filter((item) => item.name);

  const inspectorNameList = [
    ...new Map(
      uniqueInspectors?.map((item) => [
        item.fullName,
        { name: item.fullName },
      ]) || [],
    ).values(),
  ].filter((item) => item.name);

  const approverNameList = [
    ...new Map(
      uniqueApprovers?.map((item) => [
        item.fullName,
        { name: item.fullName },
      ]) || [],
    ).values(),
  ].filter((item) => item.name);

  const mapSiteNameList = [
    ...new Map(
      properties?.map((item) => [item.name, { name: item.name }]) || [],
    ).values(),
  ].filter((item) => item.name);

  useEffect(() => {
    setCity(cityObj?.cityList);
  }, [cityObj.cityList, cityObj.loading]);

  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });

  // Close or hide the toast notification.
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };
  // const navigate = useNavigate();
  const clientObj = useGetClientId();

  const fetchPropertiesList = useCallback(async () => {
    try {
      const response = await http.get(
        `${GET_PROPERTIES_LIST}?clientId=${clientObj?.clientId}`,
      );

      if (response.status === 200) {
        setProperties(response.data);
      }
    } catch (error) {
      console.error("Error fetching properties:", error);
    } finally {
      setLoading(false);
    }
  }, [clientObj?.clientId]);

  const getBlockByClientID = useCallback(async (clientId) => {
    try {
      const response = await http.get(
        GET_BLOCK_BY_CLIENT_ID + "?clientId=" + clientId,
      );
      if (response.status === 200) {
        setBlocksList(response?.data?.blocks);
      }
    } catch (error) {
      return error;
    }
  }, []);

  const getUsersRoleByClientId = useCallback(async (clientId) => {
    try {
      const response = await http.get(
        GET_USERS_ROLE_BY_CLIENT_ID + "?clientId=" + clientId,
      );
      if (response.status === 200) {
        // Filter roles
        const approvers = response?.data?.filter(
          (item) => item.roleName === "Approver" && item.active === true,
        );
        const inspectors = response?.data?.filter(
          (item) => item.roleName === "Inspector" && item.active === true,
        );

        // Dropdown options
        const approverOptions = approvers.map((a) => ({
          value: a.userId,
          label: a.fullName,
        }));

        const inspectorOptions = inspectors.map((i) => ({
          value: i.userId,
          label: i.fullName,
        }));
        setInspectorList(inspectorOptions);
        setApproverList(approverOptions);
      }
    } catch (error) {
      return error;
    }
  }, []);

  const handleGetAllPropertyByClinetID = useCallback(async (clientId) => {
    try {
      const response = await http.get(
        GET_ALL_PROPERTY_BY_CLIENT_ID + "?clientId=" + clientId,
      );
      if (response.status === 200) {
        console.log("response.data", response.data);
        // response?.data?.forEach((item) => {
        //   item.id = item.propertyMasterId; // Assigning a sequential ID
        // });
        const allproperties = response?.data;
        const responseBuildings = await http.get(
          GET_PROPERTY_WITH_BUILDING + "?clientId=" + clientId,
        );
        if (responseBuildings.status === 200) {
          console.log("buildings", responseBuildings);

          const flattenedProperties = allproperties.flatMap((property) => {
            const matchedProperty = responseBuildings?.data?.find(
              (p) => p.propertyMasterId === property.propertyMasterId,
            );

            if (!matchedProperty || !matchedProperty.blocks?.length) {
              return [
                {
                  ...property,
                  blockId: null,
                  blockName: null,
                  buildingNo: null,
                },
              ];
            }

            return matchedProperty.blocks.map((block) => ({
              ...property,
              blockId: block.blockId,
              blockName: block.blockName,
              buildingNo: block.buildingNo,
            }));
          });

          flattenedProperties?.forEach((item) => {
            item.id = item.propertyMasterId + "_" + item.blockId; // Assigning a sequential ID
          });
          // setPropertyBuildingList(responseBuildings?.data);
          setAllPropertyList(flattenedProperties);
        }
        // Also refresh the properties list for map view dropdown
        fetchPropertiesList();
      }
    } catch (error) {
      return error;
    } finally {
      setLoading(false);
    }
  }, [fetchPropertiesList]);

  useEffect(() => {
    if (clientObj.clientId) {
      getBlockByClientID(clientObj.clientId);
      handleGetAllPropertyByClinetID(clientObj.clientId);
      getUsersRoleByClientId(clientObj.clientId);
    }
  }, [clientObj.clientId, clientObj.loading, getBlockByClientID, handleGetAllPropertyByClinetID, getUsersRoleByClientId]);

  // const handleGetAllPropertyByClinetID = async (clientId) => {
  //   try {
  //     const response = await http.get(
  //       GET_ALL_PROPERTY_BY_CLIENT_ID + "?clientId=" + clientId,
  //     );
  //     if (response.status === 200) {
  //       console.log("response.data", response.data);
  //       response?.data?.forEach((item) => {
  //         item.id = item.propertyMasterId; // Assigning a sequential ID
  //       });
  //       setAllPropertyList(response.data);
  //     }
  //   } catch (error) {
  //     return error;
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  

  const handleEditProperty = (id) => {
    const editPropertyDetails = allPropertyList?.filter((data) => {
      return data.propertyMasterId === id;
    });
    setEditProperty(editPropertyDetails);
    setRenderUpdateProperty(true);
  };

  const handleDeleteProperty = async (data) => {
    // const newFormPayload = {
    //   clientId: clientObj.clientId,
    //   propertyMasterId: data?.propertyMasterId,
    // blockName: data.blockName,
    // blockId: data.blockId,
    // isActive: false,
    // propertyName: data.propertyName,
    // propertyLocation: data.propertyAddress || "",
    // postalCode: data.propertyPostalCode || "",
    // propertyImage: data.propertyImage || "",
    // cityId: data.cityId.toString() || "",
    // inspectors: (data.inspectors || []).map((i) => i.userId ?? i),
    // approvers: (data.approvers || []).map((i) => i.userId ?? i),
    // complianceDocs: data.complianceDocs || [],
    // totalNoOfFloors: parseInt(data.totalNoOfFloors, 10) || 0,
    // propertyStatus: data.propertyStatus || "Active",
    // };
    const params = new URLSearchParams();
    params.append("propertyMasterId", data?.propertyMasterId);
    params.append("ClientId", clientObj?.clientId);
    params.append("LoggedinUserEMail", userObj?.userEmail);
    if (data?.blockId) {
      params.append("BuildingId", data?.blockId);
    }
    const queryString = params.toString();
    try {
      const response = await http.delete(
        DELETE_PROPERTY_BY_MASTER_ID + `?${queryString}`,
      );
      // if (response.status === 200 && response?.data?.result?.isSuccess) {
      //   setTimeout(() => {
      //     setToastData({
      //       toastShow: true,
      //       toastType: "success",
      //       toastString: response?.data?.result?.message,
      //     });
      //   }, 2000);

      //   // setShowUpdatePropertyModal(false);
      //   handleGetAllPropertyByClinetID(clientObj.clientId);
      // }
      // if (response.status === 200 && response?.data?.result?.isSuccess) {
      //   setToastData({
      //     toastShow: true,
      //     toastType: "success",
      //     toastString: response?.data?.result?.message,
      //   });

      //   handleGetAllPropertyByClinetID(clientObj.clientId);
      // }
      if (response.status === 200 && response?.data?.result?.isSuccess) {
        console.log("delete api call in click");
        setToastData({
          toastShow: true,
          toastType: "success",
          // toastString: response?.data?.result?.message,
          toastString: "Building has been successfully deleted.",
        });

        setTimeout(() => {
          handleGetAllPropertyByClinetID(clientObj.clientId);
        }, 300);
      } else {
        setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "failure",
            toastString: response?.data?.result?.message,
          });
        }, 2000);
      }
    } catch (error) {
      return error;
    }
  };
  useEffect(() => {
    if (!clientObj?.clientId) return;
    fetchPropertiesList();
  }, [clientObj?.clientId, fetchPropertiesList]);

  const RESET_TILE_FILTERS = {
    searchText: "",
    property_name: "Propertyname",
    building_name: "BuildingName",
    inspector: "Inspector",
    approver: "Approver",
    propertyType: "Property Type",
  };

  const RESET_MAP_FILTERS = {
    searchText: "",
    name: "",
  };
  const handleTileViewClick = () => {
    setActiveView("tile");
    setToolBar((prev) => ({
      ...prev,
      ...RESET_TILE_FILTERS,
      name: "", // clear map-only field
    }));
  };

  // const handleMapViewClick = () => {
  //   setActiveView("map");
  //   setToolBar((prev) => ({
  //     ...prev,
  //     ...RESET_MAP_FILTERS,
  //     property_name: "Propertyname",
  //     inspector: "Inspector",
  //     approver: "Approver",
  //     propertyType: "Property Type",
  //   }));
  // };
  const handleMapViewClick = () => {
    setActiveView("map");
    setToolBar((prev) => ({
      ...prev,
      ...RESET_MAP_FILTERS,
      property_name: "Propertyname",
      building_name: "BuildingName",
      inspector: "Inspector",
      approver: "Approver",
      propertyType: "Property Type",
    }));
    // Refresh properties list when switching to map view
    if (clientObj?.clientId) {
      fetchPropertiesList();
    }
  };
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [propertyToDelete, setPropertyToDelete] = useState(null);
  const tableColumns = [
    {
      field: "Actions",
      headerName: "Actions",
      width: 120,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: false,
      filterable: false,
      type: "string",
      minWidth: 120,
      flex: 0.4,
      renderCell: (params) => (
        <IconButton size="small" onClick={(e) => handleMenuOpen(e, params.row)}>
          <MoreVertIcon />
        </IconButton>
      ),
      renderHeader: () => (
        <span style={{ display: "flex", alignItems: "center" }}>
          <span className="personalFont">Actions</span>

          <i
            className="bi bi-info-circle"
            style={{
              fontSize: "0.9rem",
              marginLeft: "5px",
              cursor: "pointer",
            }}
            title="Click the three dots menu for each Site to access edit/delete site details, create inspection and view inspection history, also generate RMS link for each site."
          ></i>
        </span>
      ),
    },
    {
      field: "propertyName",
      height: 50,
      width: 250,
      minWidth: 250,
      headerName: "Site Name",
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      flex: 1,
      type: "string",
    },
    {
      field: "propertyLocation",
      height: 50,
      width: 220,
      minWidth: 220,
      headerName: "Site Address",
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      flex: 1,
      type: "string",
    },
    {
      field: "numberOfBlocks",
      width: 120,
      height: 50,
      headerName: "Number of Buildings",
      headerClassName: "super-app-theme--header",
      editable: false,
      filterable: true,
      sortable: true,
      type: "string",
      minWidth: 120,
      flex: 1,
      renderCell: (data) => {
        return (
          <>
            {data?.row?.numberOfBlocks === null
              ? "-"
              : data?.row?.numberOfBlocks}
          </>
        );
      },
    },
    {
      field: "blockName",
      height: 50,
      width: 200,
      minWidth: 200,
      headerName: "Building Name",
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      flex: 1,
      type: "string",
    },
    {
      field: "inspectors",
      headerName: "Inspector(s)",
      width: 220,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      type: "string",
      minWidth: 220,
      flex: 1,
      renderCell: (data) => {
        return (
          <>{data?.row?.inspectors?.map((item) => item.fullName).join(", ")}</>
        );
      },
    },
    {
      field: "approvers",
      headerName: "Approver(s)",
      width: 220,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      type: "string",
      minWidth: 220,
      flex: 1,
      renderCell: (data) => {
        return (
          <>{data?.row?.approvers?.map((item) => item.fullName).join(", ")}</>
        );
      },
    },

    // {
    //   field: "propertyStatus",
    //   headerName: "Property Type",
    //   width: 60,
    //   height: 50,
    //   headerClassName: "super-app-theme--header",
    //   editable: false,
    //   sortable: true,
    //   filterable: true,
    //   type: "string",
    //   minWidth: 60,
    //   flex: 0.6,
    // },

    // {
    //   field: "Actions",
    //   headerName: "Actions",
    //   width: 60,
    //   height: 50,
    //   headerClassName: "super-app-theme--header",
    //   editable: false,
    //   sortable: false,
    //   filterable: false,
    //   type: "string",
    //   minWidth: 60,
    //   flex: 1,
    //   renderCell: (data) => (
    //     <Box>
    //       <img
    //         tabIndex={0}
    //         title="Edit Property"
    //         alt="Edit Property"
    //         onClick={() => {
    //           handleEditProperty(data?.row?.propertyMasterId);
    //         }}
    //         src={activeEditIcon}
    //         style={{ cursor: "pointer" }}
    //       ></img>

    //       <img
    //         tabIndex={0}
    //         title="Delete Property"
    //         alt="Delete Property"
    //         onClick={() => {
    //           setPropertyToDelete(data?.row);
    //           setShowDeleteModal(true);
    //         }}
    //         src={activeDeleteIcon}
    //         style={{ cursor: "pointer" }}
    //       ></img>
    //     </Box>
    //   ),
    // },
  ];

  const generateRmsLink = async (row) => {
    try {
      setLoading(true);

      const response = await http.put(
        `${RMS_LINK}?clientId=${clientObj.clientId}&propertyMasterId=${row.propertyMasterId}&buildingId=${row.blockId}`,
      );

      if (response.status === 200 && response.data?.isSuccess) {
        const newUrl = response.data?.rmsUrl;

        // setRmsLinkData({
        //   description: `RMS link for ${row.propertyName}`,
        //   href: newUrl,
        // });
        setRmsLinkData({
          description: (
            <>
              <strong>
                {" "}
                RMS link for {row.propertyName} : {row.blockName}
              </strong>
            </>
          ),
          href: newUrl,
        });

        setShowRmsLinkPopup(true);

        setAllPropertyList((prev) =>
          prev.map((item) =>
            item.propertyMasterId === row.propertyMasterId
              ? { ...item, rmsPropertyUrl: newUrl }
              : item,
          ),
        );

        setToastData({
          toastShow: true,
          toastType: "success",
          toastString: response.data?.message,
        });
      } else {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: response.data?.message || "Failed to generate RMS link",
        });
      }
    } catch (error) {
      console.error(error);
      setToastData({
        toastShow: true,
        toastType: "failure",
        toastString: "Something went wrong while generating RMS link",
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchDownloadExcel = async () => {
    //excel export
    try {
      setLoading(true);
      const params = new URLSearchParams();
      params.append("clientId", clientObj?.clientId);
      const queryString = params.toString();
      const response = await http.get(EXPORT_EXCEL_PROPERTIES + `?${queryString}`, {
        responseType: "blob",
      });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const contentDisposition = response.headers["content-disposition"];
      let fileName = "FDS_SiteDetails.xlsx";

      if (contentDisposition) {
        const match = contentDisposition.match(
          /filename\*?=(?:UTF-8'')?([^;]+)/,
        );
        if (match && match[1]) {
          fileName = decodeURIComponent(match[1].replace(/"/g, ""));
        }
      }
      if (
        navigator.userAgent.includes("Safari") &&
        !navigator.userAgent.includes("Chrome")
      ) {
        const reader = new FileReader();

        reader.onloadend = () => {
          const link = document.createElement("a");
          link.href = reader.result;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          link.remove();
        };

        reader.readAsDataURL(blob);
      } else {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }

      setToastData({
        toastShow: true,
        toastType: "success",
        toastString: "Excel file downloaded successfully.",
      });
    } catch (err) {
      console.error(err);
      const errmss =
        err?.response?.data?.message ??
        err?.message ??
        "Failed to download Excel file";
      setToastData({
        toastShow: true,
        toastType: "failure",
        toastString: errmss,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
        <MenuItem
          onClick={() => {
            if (!selectedRow) return;

            // const existingUrl = selectedRow?.rmsPropertyUrl;
            // console.log("rms", selectedRow)

            // if (existingUrl) {
            //   const formattedUrl = existingUrl.startsWith("http")
            //     ? existingUrl
            //     : `https://${existingUrl}`;

            //   // setRmsLinkData({
            //   //   description: `RMS link for ${selectedRow.propertyName}`,
            //   //   href: formattedUrl,
            //   // });
            //   setRmsLinkData({
            //     description: (
            //       <>
            //         <strong> RMS link for {selectedRow.propertyName} : {selectedRow.blockName}</strong>
            //       </>
            //     ),
            //     href: formattedUrl,
            //   });

            //   setShowRmsLinkPopup(true);
            // } else {
            generateRmsLink(selectedRow);
            // }

            handleMenuClose();
          }}
        >
          <i className="fa-solid fa-link" style={{ marginRight: 8 }} />
          RMS Link
        </MenuItem>
        <MenuItem
          onClick={() => {
            const path = generatePath(
              "/client/:clientNameParam/viewInspectionHistory/:propertyMasterId",
              {
                clientNameParam: clientNameParam,
                propertyMasterId: selectedRow?.propertyMasterId,
              },
            );

            navigate(path, {
              state: {
                propertyName: selectedRow?.propertyName,
              },
            });
            handleMenuClose();
          }}
        >
          {/* <i className="fa-solid fa-eye fa-sm" style={{ marginRight: 8 }} />
           */}
          <img
            src={activeHistoryIcon}
            width={16}
            style={{
              marginRight: 8,
              filter: "brightness(0)",
            }}
          />
          View Inspection History
        </MenuItem>
        <MenuItem
          onClick={() => {
            const path = generatePath("/client/:clientNameParam/inspection", {
              clientNameParam,
            });

            navigate(path, {
              state: {
                propertyMasterId: selectedRow?.propertyMasterId,
                propertyName: selectedRow?.propertyName,
                blockId: selectedRow?.blockId,
                blockName: selectedRow?.blockName,
              },
            });

            handleMenuClose();
          }}
        >
          <AddIcon fontSize="small" sx={{ mr: 1 }} />
          Create Inspection
        </MenuItem>
        <MenuItem
          onClick={() => {
            const path = generatePath(
              "/client/:clientNameParam/viewSite/:propertyMasterId",
              {
                clientNameParam,
                propertyMasterId: selectedRow?.propertyMasterId,
              },
            );
            navigate(path);
            handleMenuClose();
          }}
        >
          <i className="fa-solid fa-eye" style={{ marginRight: 8 }} />
          View Site Details
        </MenuItem>
        <MenuItem
          onClick={() => {
            const path = generatePath(
              "/client/:clientNameParam/editSite/:propertyMasterId",
              {
                clientNameParam,
                propertyMasterId: selectedRow?.propertyMasterId,
              },
            );
            navigate(path);
            // handleEditProperty(selectedRow?.propertyMasterId);
            handleMenuClose();
          }}
        >
          <EditIcon fontSize="small" sx={{ mr: 1 }} />
          Edit Site Details
        </MenuItem>

        <MenuItem
          onClick={() => {
            setPropertyToDelete(selectedRow);
            setShowDeleteModal(true);
            handleMenuClose();
          }}
        >
          <DeleteIcon fontSize="small" sx={{ mr: 1 }} />
          Delete Building
        </MenuItem>
      </Menu>

      <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      {userObj && (
        <div className="dashboard_body_main paddingClassForAddProperty">
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          )}
          <>
            {renderAddProperty ? (
              <AddSiteBlock
                setRenderAddProperty={setRenderAddProperty}
                blocksList={blocksList}
                clientId={clientObj.clientId}
                handleGetAllPropertyByClinetID={handleGetAllPropertyByClinetID}
              />
            ) : renderUpdateProperty ? (
              <UpdateProperty
                setRenderUpdateProperty={setRenderUpdateProperty}
                blocksList={blocksList}
                editPropertyDetails={editProperty[0]}
                clientId={clientObj.clientId}
                handleGetAllPropertyByClinetID={handleGetAllPropertyByClinetID}
                cityList={city}
                inspectorList={inspectorList}
                approverList={approverList}
                setToastData={setToastData}
              />
            ) : (
              <div className="d-flex dashboard_body flex-column py-1 w-100">
                <div className="w-100">
                  <div className="col-sm-12 d-flex justify-content-between m-0 mt-3 align-items-end">
                    <div className="text-start">
                      <p className="fs-3 fw-bold m-0">Site Dashboard</p>
                      <p className="fs-6 m-0">
                        Manage and track all Sites and their Buildings.
                      </p>
                    </div>
                    <div className="col-auto ms-auto">
                      <Tooltip
                        title="Export to excel"
                        arrow
                        slotProps={{
                          tooltip: {
                            sx: {
                              bgcolor: "#fff",
                              color: "#000",
                              fontSize: "12px",
                              boxShadow: "0px 2px 8px rgba(0,0,0,0.15)",
                            },
                          },
                          arrow: {
                            sx: {
                              color: "#fff",
                            },
                          },
                        }}
                      >
                        <span>
                          <button
                            type="button"
                            className="btn btn-outline"
                            // title="Export to excel"
                            onClick={() => fetchDownloadExcel()}
                          >
                            <img src={downloadIcon}></img>
                          </button>
                        </span>
                      </Tooltip>
                      <button
                        type="button"
                        className="btn btn-primary custom_toolbar_btn mx-2"
                        onClick={() => {
                          setRenderAddProperty(true);
                          navigate(
                            generatePath("/client/:clientNameParam/addSite", {
                              clientNameParam,
                            }),
                          );
                        }}
                      >
                        <i className=" fa-solid fa-plus addBlock"></i> Add New
                        Site
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary custom_toolbar_btn"
                        onClick={() =>
                          navigate(
                            generatePath(
                              "/client/:clientNameParam/inspection",
                              {
                                clientNameParam,
                              },
                            ),
                          )
                        }
                      >
                        <i className=" fa-solid fa-plus addBlock"></i> New
                        Inspection
                      </button>
                    </div>
                  </div>

                  <div className="row py-3 align-items-center g-1">
                    {activeView === "tile" && (
                      <>
                        {/* Search Bar */}
                        <div className="custom_toolbar_search col-6 col-md-2">
                          <img src={searchIcon} />
                          <input
                            type="text"
                            className="form-control custom_toolbar_control"
                            placeholder="Search..." // kept your text
                            value={toolbar.searchText}
                            onChange={(e) =>
                              setToolBar({
                                ...toolbar,
                                searchText: e.target.value,
                              })
                            }
                          />
                        </div>
                        {/* Dropdowns */}
                        <div className="col-6 col-md-2">
                          {/* <select
                            className="form-select custom_toolbar_control"
                            value={toolbar.property_name}
                            onChange={(e) =>
                              setToolBar({
                                ...toolbar,
                                property_name: e.target.value,
                              })
                            }
                          >
                            <option value="Propertyname">Site Name</option>
                            {[
                              ...new Set(
                                allPropertyList?.map(
                                  (user) => user.propertyName,
                                ),
                              ),
                            ]
                              .sort((a, b) => a.localeCompare(b))
                              .map((item, index) => (
                                <option key={index} value={item}>
                                  {item}
                                </option>
                              ))}
                          </select> */}

                          <AutocompleteInput
                            masterList={propertyNameList}
                            getOptionLabel={(item) => item?.name || ""}
                            getOptionValue={(item) => item?.name || ""}
                            value={
                              toolbar.property_name === "Propertyname"
                                ? ""
                                : toolbar.property_name
                            }
                            onValueChange={(value) =>
                              setToolBar({
                                ...toolbar,
                                property_name: value || "Propertyname",
                              })
                            }
                            placeholder="Site Name"
                            inputClassName="form-control custom_toolbar_control mt-1"
                            notFoundText="Site not found"
                          />
                        </div>

                        <div className="col-6 col-md-2">
                          <AutocompleteInput
                            masterList={buildingNameList}
                            getOptionLabel={(item) => item?.name || ""}
                            getOptionValue={(item) => item?.name || ""}
                            value={
                              toolbar.building_name === "BuildingName"
                                ? ""
                                : toolbar.building_name
                            }
                            onValueChange={(value) =>
                              setToolBar({
                                ...toolbar,
                                building_name: value || "BuildingName",
                              })
                            }
                            placeholder="Building Name"
                            inputClassName="form-control custom_toolbar_control mt-1"
                            notFoundText="Building not found"
                          />
                        </div>

                        <div className="col-6 col-md-2">
                          {/* <select
                            className="form-select custom_toolbar_control"
                            value={toolbar.inspector}
                            onChange={(e) =>
                              setToolBar({
                                ...toolbar,
                                inspector: e.target.value,
                              })
                            }
                          >
                            <option value="Inspector">Inspector(s)</option>
                            {uniqueInspectors
                              .sort((a, b) =>
                                a.fullName.localeCompare(
                                  b.fullName,
                                  undefined,
                                  {
                                    sensitivity: "base",
                                  },
                                ),
                              )

                              .map((inspector) => (
                                <option
                                  key={inspector.userId}
                                  value={inspector.fullName}
                                >
                                  {inspector.fullName}
                                </option>
                              ))}
                          </select> */}

                          <AutocompleteInput
                            masterList={inspectorNameList}
                            getOptionLabel={(item) => item?.name || ""}
                            getOptionValue={(item) => item?.name || ""}
                            value={
                              toolbar.inspector === "Inspector"
                                ? ""
                                : toolbar.inspector
                            }
                            onValueChange={(value) =>
                              setToolBar({
                                ...toolbar,
                                inspector: value || "Inspector",
                              })
                            }
                            placeholder="Inspector(s)"
                            inputClassName="form-control custom_toolbar_control mt-1"
                            notFoundText="Inspector not found"
                          />
                        </div>

                        <div className="col-6 col-md-2">
                          {/* <select
                            className="form-select custom_toolbar_control"
                            value={toolbar.approver}
                            onChange={(e) =>
                              setToolBar({
                                ...toolbar,
                                approver: e.target.value,
                              })
                            }
                          >
                            <option value="Approver">Approver(s)</option>
                            {uniqueApprovers
                              .sort((a, b) =>
                                a.fullName.localeCompare(
                                  b.fullName,
                                  undefined,
                                  {
                                    sensitivity: "base",
                                  },
                                ),
                              )
                              .map((approver) => (
                                <option
                                  key={approver.userId}
                                  value={approver.fullName}
                                >
                                  {approver.fullName}
                                </option>
                              ))}
                          </select> */}
                          <AutocompleteInput
                            masterList={approverNameList}
                            getOptionLabel={(item) => item?.name || ""}
                            getOptionValue={(item) => item?.name || ""}
                            value={
                              toolbar.approver === "Approver"
                                ? ""
                                : toolbar.approver
                            }
                            onValueChange={(value) =>
                              setToolBar({
                                ...toolbar,
                                approver: value || "Approver",
                              })
                            }
                            placeholder="Approver(s)"
                            inputClassName="form-control custom_toolbar_control mt-1"
                            notFoundText="Approver not found"
                          />
                        </div>

                        {/* <div className="col-6 col-md-1">
                          <select
                            className="form-select custom_toolbar_control"
                            value={toolbar.propertyType}
                            onChange={(e) =>
                              setToolBar({
                                ...toolbar,
                                propertyType: e.target.value,
                              })
                            }
                          >
                            <option value="Property Type">Type</option>
                            {[
                              ...new Set(
                                allPropertyList?.map(
                                  (user) => user.propertyStatus,
                                ),
                              ),
                            ]
                              .sort((a, b) => a.localeCompare(b))
                              .map((item, index) => (
                                <option key={index} value={item}>
                                  {item}
                                </option>
                              ))}
                          </select>
                        </div> */}
                      </>
                    )}
                    {activeView === "map" && (
                      <>
                        {/* Search Bar */}
                        <div className="custom_toolbar_search col-6 col-md-3">
                          <img src={searchIcon} />
                          <input
                            type="text"
                            className="form-control custom_toolbar_control"
                            placeholder="Search properties"
                            value={toolbar.searchText}
                            onFocus={() => {
                              setToolBar((prev) => ({
                                ...prev,
                                name: "",
                                property_name: "Propertyname",
                              }));
                            }}
                            onChange={(e) => {
                              const value = e.target.value;
                              setToolBar((prev) => ({
                                ...prev,
                                searchText: value,
                                name: "",
                              }));
                            }}
                          />
                        </div>
                        {/* Dropdowns */}
                        {/* <div className="col-6 col-md-2">
                          <select
                            className="form-select custom_toolbar_control"
                            value={toolbar.name}
                            onChange={(e) =>
                              setToolBar((prev) => ({
                                ...prev,
                                name: e.target.value,
                                searchText: "",
                              }))
                            }
                          >
                            <option value="">Site Name</option>

                            {[...new Set(properties.map((p) => p.name))]
                              .filter(Boolean)
                              .map((name, index) => (
                                <option key={index} value={name}>
                                  {name}
                                </option>
                              ))}
                          </select>
                        </div> */}
                        <div className="col-6 col-md-2">
                          <AutocompleteInput
                            masterList={mapSiteNameList}
                            getOptionLabel={(item) => item?.name || ""}
                            getOptionValue={(item) => item?.name || ""}
                            value={toolbar.name || ""}
                            onValueChange={(value) =>
                              setToolBar((prev) => ({
                                ...prev,
                                name: value || "",
                                searchText: value ? "" : prev.searchText,
                              }))
                            }
                            placeholder="Site Name"
                            inputClassName="form-control custom_toolbar_control mt-1"
                            notFoundText="Site not found"
                          />
                        </div>
                      </>
                    )}
                    <div className="col-1 ms-auto property-view-toggle ">
                      <div
                        className={`slider ${activeView === "map" ? "right" : "left"}`}
                      />

                      <button
                        className={`btn custom_toolbar_btn view-btn ${
                          activeView === "tile" ? "active" : ""
                        }`}
                        onClick={handleTileViewClick}
                      >
                        <i className="fa fa-list" aria-hidden="true"></i>
                      </button>

                      <button
                        className={`btn custom_toolbar_btn view-btn ${
                          activeView === "map" ? "active" : ""
                        }`}
                        onClick={handleMapViewClick}
                      >
                        <i className="fas fa-map-marker-alt"></i>
                      </button>
                    </div>

                    {/* <div className="col-6 col-md-1">
                  <button
                        type="button"
                        className="btn btn-primary custom_toolbar_btn mx-2"
                      >
                        Tile view
                      </button>
                    </div>
                    <div className="col-6 col-md-1">
                    <button
                        type="button"
                        className="btn btn-primary custom_toolbar_btn mx-2"
                      >
                       Map View
                      </button>
                    </div> */}
                    {isAnyFilterApplied && (
                      <div style={{ width: "auto", paddingLeft: "0px" }}>
                        <IconButton
                          tabIndex={0}
                          title="Clear Filters"
                          onClick={() => {
                            setToolBar({
                              searchText: "",
                              property_name: "Propertyname",
                              building_name: "BuildingName",
                              inspector: "Inspector",
                              approver: "Approver",
                              propertyType: "Property Type",
                            });
                          }}
                        >
                          <ClearIcon
                            sx={{ color: "#717186" }}
                            fontSize="small"
                          />
                        </IconButton>
                      </div>
                    )}

                    {/* Export Button */}
                  </div>
                  {activeView === "tile" && (
                    <div
                      className="inspection-table"
                      style={{ paddingTop: "10px" }}
                    >
                      <DynamicTable
                        tableData={filteredRows}
                        columnsValue={tableColumns}
                        pageSize={10}
                        rowHeight={45}
                        pageSizeOptions={[
                          100,
                          150,
                          200,
                          { value: -1, label: "All" },
                        ]}
                      />
                    </div>
                  )}
                  <div
                    style={{ display: activeView === "map" ? "block" : "none" }}
                  >
                    <PropertyList
                      searchText={toolbar.searchText}
                      propertyName={toolbar.name}
                      key={activeView}
                    />
                  </div>
                  <div className="inspection-tile">
                    {filteredRows &&
                      filteredRows?.map((item) => {
                        return (
                          // eslint-disable-next-line react/jsx-key
                          <DynamicTiles
                            tableData={item}
                            module="addPropertyDashboard"
                            setPropertyToDelete={setPropertyToDelete}
                            setShowDeleteModal={setShowDeleteModal}
                            handleEditProperty={() =>
                              handleEditProperty(item.propertyMasterId)
                            }
                          />
                        );
                      })}
                  </div>
                </div>
              </div>
            )}
            <Footer />
            <div className="bottom-bar-spacing"></div>
            <BottomBarIcons />
            <LoadingComponent loading={loading} />
            {showDeleteModal && (
              <ConfirmationPopup
                show={showDeleteModal}
                headingText="Confirm Delete"
                infoText="Are you sure you want to delete this building? Deleting will mark all the existing active inspections for this building in the site as cancelled."
                cancelText="Cancel"
                submitText="Yes, Delete"
                onCancel={() => {
                  setShowDeleteModal(false);
                  setPropertyToDelete(null);
                }}
                onSubmit={() => {
                  if (propertyToDelete) {
                    handleDeleteProperty(propertyToDelete);
                  }
                  setShowDeleteModal(false);
                }}
              />
            )}

            {showRmsLinkPopup && (
              <div className="modal-overlay">
                <div
                  className="approval-modal-content"
                  style={{ height: "auto" }}
                >
                  <i
                    className="fa-solid fa-xmark fa-sm close-icon mt-2"
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowRmsLinkPopup(false)}
                  ></i>

                  <div className="modal-body p-3">
                    {/* <h6 className="mb-3 fw-semibold">RMS Link</h6> */}

                    <h6 className="text-muted mb-2">
                      {rmsLinkData.description}
                    </h6>

                    <div className="form-group">
                      {/* <label className="fw-semibold">Link</label> */}
                      <div
                        className="p-2 mt-1"
                        style={{
                          background: "#f5f5f5",
                          borderRadius: "6px",
                          wordBreak: "break-all",
                        }}
                      >
                        <a
                          href={rmsLinkData.href}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-primary"
                        >
                          {rmsLinkData.href}
                        </a>
                      </div>
                    </div>

                    <div className="d-flex justify-content-end gap-3 mt-4">
                      <button
                        type="button"
                        className="btn-secondary"
                        onClick={() => setShowRmsLinkPopup(false)}
                      >
                        Close
                      </button>

                      <button
                        type="button"
                        className="btn-primary"
                        onClick={() => {
                          navigator.clipboard.writeText(rmsLinkData.href);
                          setToastData({
                            toastShow: true,
                            toastType: "success",
                            toastString: "Link copied to clipboard",
                          });
                        }}
                      >
                        Copy Link
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}


            <Toaster
              show={toastData.toastShow}
              toastType={toastData.toastType}
              title={toastData.toastString}
              theme={"dark"}
              position="top-center"
              closeButton={closeButton}
            />
          </>
          {/* // )} */}
        </div>
      )}
    </>
  );
};

export default AddProperty;
